import { useWeddingAudio } from "@/components/wedding/WeddingAudioContext";

export default function AudioToggle() {
  const { play, pause, isPlaying } = useWeddingAudio();

  const handleClick = () => {
    if (isPlaying) {
      pause();
    } else {
      play();
    }
  };

  return (
    <button
      onClick={handleClick}
      aria-label={isPlaying ? "Pause music" : "Play music"}
      className="audio-toggle"
    >
      {isPlaying ? (
        // Pause icon
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
          <rect x="6" y="4" width="4" height="16" />
          <rect x="14" y="4" width="4" height="16" />
        </svg>
      ) : (
        // Play icon
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
          <path d="M8 5v14l11-7z" />
        </svg>
      )}
    </button>
  );
}